import { render, staticRenderFns } from "./AssignToSalesGroup.vue?vue&type=template&id=c12cd804"
import script from "./AssignToSalesGroup.vue?vue&type=script&lang=js"
export * from "./AssignToSalesGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports